import { SERVER_URL } from "../config/backend";

export async function faqs(globalLang) {
    var result = [];

    var query = `
        query faqs($skip:Int!,$take:Int!,$report:Boolean!){
            faqs(skip:$skip, take:$take,report:$report){
                status,
                errors{
                    field,
                    messages
                },
                objects{
                    id,
                    question,
                    answer
                }
            }
        }
    `;

    await fetch(`${SERVER_URL}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Clientid: "3iwUHcPNqqHz6AIvzhlpgHdfAfOTJVZth84BX8bh",
            Clientsecret: "ivvDiNohSNdPmyAHv2IR7yHBLp3taXpvQEuwU4CrrMULAc3dnwYVX0Ughe8Dqk1rptnBWojPbVhf25duC0NqWniH5MOOS1ryQ9LgoNeiXgWCMU4cLQAZagOuAteFrgza",
            language: globalLang,
        },
        body: JSON.stringify({
            operationName: "faqs",
            query: query,
            variables: {
                skip: 1,
                take: 100,
                report: true,
            },
        }),
    })
        .then((r) => r.json())
        .then((data) => {
            if (data["data"]["faqs"]["status"] === 200) {
                result["erros"] = data["data"]["faqs"]["errors"];
                result["faqs"] = data["data"]["faqs"]["objects"];
            } else {
                result = data["data"]["faqs"]["errors"];
            }
        });

    return result;
}
